import { render, staticRenderFns } from "./product-six-dimensional.vue?vue&type=template&id=46d342b8&scoped=true&"
import script from "./product-six-dimensional.vue?vue&type=script&lang=js&"
export * from "./product-six-dimensional.vue?vue&type=script&lang=js&"
import style0 from "./product-six-dimensional.vue?vue&type=style&index=0&id=46d342b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d342b8",
  null
  
)

export default component.exports